<template>
  <div id="Dashboard"  class="container is-fluid">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">

    <!-- Header -->
    <HeroContainer title="Rules Detail Dashboard" />

    <section id="filters" style="display:flex; justify-content:center;">
      <div style="width:500px" >
        
        <div class="control is-expanded">
          <div class="select" style="width:100%">
            <select style="width:100%" v-model="selected_index">
              <option disabled hidden selected value=-1>Rule</option>
              <option v-for="(rule, index) in rules" :key="rule.id" :value="index">{{rule.name}}</option>
            </select>
          </div>
        </div>
        
        <div v-if="selected_index >= 0">
          <div style="margin-top:2em; font-weight:bold;">
            Description
          </div>

          
          <div style="margin-top:1em; display:flex; align-items:top;">
            <textarea type="text" class="input" style="min-height:10em;"
                v-model="rules[selected_index].description" disabled/>
          </div>

          <div style="margin-top:2em; font-weight:bold;">
            Sales Instructions
          </div>

          
          <div style="margin-top:1em; display:flex; align-items:top;">
            <textarea type="text" class="input" style="min-height:10em;"
                v-model="rules[selected_index].instructions" disabled/>
          </div>
          

          <div style="margin-top:4em; font-weight:bold;">
            Search Rule Matches
          </div>
            <div class="field has-addons" style="margin-top:1em;">
              <p class="control">
                <span class="select">
                  <select id="date_range" 
                    v-model="date_range" @change="change_date(date_range)">
                    <option disabled hidden value="" style="color:grey;">Date Presets</option>
                    <option value='today'>Today</option>
                    <option value='week'>Week</option>
                    <option value='this_month'>This Month</option>
                    <option value='prev_month'>Prev Month</option>
                    <option value='this_quarter'>This Quarter</option>
                    <option value='prev_quarter'>Prev Quarter</option>
                    <option value='this_year'>This Year</option>
                    <option value='prev_year'>Prev Year</option>
                    <option value='all'>All</option>
                    <option disabled hidden value='custom'>Custom</option>
                  </select>
                </span>
              </p>

              <p class="control  is-expanded">
                <DatePicker style="display:inline; flex-grow:5;"
                  @dayclick="date_range='custom'"
                  mode='range'
                  v-model='range'
                  :input-props='{
                    style:"height:2.5em; line-height:1.5; border-bottom-left-radius: 0; border-top-left-radius: 0;"
                  }'/>
                <VueDatePicker v-model="range" :enable-time-picker="false" range/>
              </p>
            </div>

          <div class="buttons is-right">
            <button @click='ajax_rule_query' class="button is-info">Search</button>
          </div>
        </div>
      </div>
    </section>
    
    <section id="dashboard_data" v-if="queryData.data.length > 0">      
      <DataTable2 
        :raw_data="queryData"
        :name="'dash_rules_detail'"
        :columns_from_parent="[
          {
            label: 'Part Number',
            field: 'part_number',
            type: 'text',
          },
          {
            label: 'Textron List',
            field: 'textron_list_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Textron Price',
            field: 'textron_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Textron Discount',
            field: 'textron_discount',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0.00')+'%'},
          },
          {
            label: 'Textron Stock',
            field: 'textron_stock',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
          },
          {
            label: 'Textron Type',
            field: 'textron_type',
            type: 'text',
          },
          {
            label: 'Textron Defense List',
            field: 'textron_defense_list_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Textron Defense Price',
            field: 'textron_defense_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Textron Defense Discount',
            field: 'textron_defense_discount',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0.00')+'%'},
          },
          {
            label: 'Textron Defense Cost',
            field: 'textron_defense_stock',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
          },
          {
            label: 'Textron Defense Type',
            field: 'textron_defense_type',
            type: 'text',
          },
          {
            label: 'Textron Defense Next Available',
            field: 'textron_defense_next_available',
            type: 'text',
          },
          {
            label: 'Price Diff',
            field: 'price_difference',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Percent Diff',
            field: 'percent_difference',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('0,0,0,0,0.00')+'%'},
          },
          {
            label: 'Suggested Price',
            field: 'suggested_price',
            type: 'number',
            formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
          },
          {
            label: 'Time Created',
            field: 'created',
            type: 'text',
            formatFn: function(value) {return value.split('T')[0]},
          },
        ]"
      />
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [queryData.data, 'RulesDetialDashboard', null])">
          Download CSV
        </button>
      </div>
    </section>
  </div>
</template>

<style scoped>
  section#filters>div>div{
    margin-top:1em;
  }
</style>

<script>
import DataTable2 from '@/components/shared/DataTable2.vue';
import moment from 'moment';
import VueDatePicker from '@vuepic/vue-datepicker';
import { getDates } from '@/helpers/dates.js'
import {
  DASHBOARD_RULES,
  DASHBOARD_RULES_DETAILS
} from '@/data/url';
import HeroContainer from '@/components/shared/HeroContainer.vue';

export default {
  name: 'DashboardRulesDetail',
  components: {
    DataTable2,
    VueDatePicker,
    HeroContainer,
  },
  data: function(){
    return {
      numeral: require('numeral'),
      rules: [],
      selected_index: -1,
      
      date_range: 'week',
      range: [
        moment().subtract(1, 'weeks').toDate(),
        moment().toDate()
      ],
      queryDataRaw: [],
    };
  },
  computed:{
    selected_rule_id(){
      if (this.selected_index < 0){
        return 0
      }
      let rule_id = this.rules[this.selected_index].id
      return rule_id
    },
    queryData(){
      let raw_query = [...this.queryDataRaw]
      if(Object.keys(raw_query).length == 0){
        return {site:'',data:[]}
      }
      return {site:'', data: raw_query,}
    },
  },
  mounted: function(){
    this.ajax_get_rules()
  },
  methods: {
    getDates,
    reset(){
      this.queryDataRaw = []
      this.part_number = ''
      this.price_difference = ''
      this.percent_difference = ''
      this.date_range = 'week'
      this.range = [
        moment().subtract(1, 'weeks').toDate(),
        moment().toDate()
      ]
    },
    change_date(date_range){
      let range = this.getDates(date_range)
      if(range){
        this.range = range
      }
    },
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    ajax_get_rules(){
      let url = DASHBOARD_RULES
      this.set_searching(true)
      let this_vue = this
      function set_input(this_vue, rules){
        this_vue.rules = rules
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({}),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_input(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
    ajax_rule_query(){
      this.queryDataRaw = []
      let url = DASHBOARD_RULES_DETAILS
      this.set_searching(true)
      let this_vue = this
      function set_dash(this_vue, dashboard){
        this_vue.queryDataRaw = dashboard
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({rule_id: this.selected_rule_id }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_dash(this_vue, res.dashboard)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
  }
};

</script>
